import Slider from "react-slick"
import "../../css/videoLibrary.css"
import YouTube from "react-youtube"

const VideoLibrary = ({
  data,
}: {
  data: Array<{ title: string; timeInMinutes: string; video: string }>
}) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    swipeToSlide: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    // autoplay: true,
    // autoplaySpeed: 1000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const opts = {
    height: "150",
    width: "280",
  }

  return (
    <div className="bg-[#D9D9D9] pt-[20px] xl:pt-[30px] pb-[70px] xl:pb-[92px] mt-[20px] xl:mt-[30px]">
      <p className="text-[26px] xl:text-[30px] font-[400] text-center">
        From <span className="text-[#AB0101]">Placeaa&apos;s</span> Video
        Library
      </p>
      <div id="video_library" className="slider-container mt-[30px] xl:mt-[40px] px-[40px] xl:px-[60px]">
        <Slider {...settings}>
          {data?.map((d, index) => (
            <div key={index} className="flex flex-col gap-[4px] xl:gap-[6px]">
              <div className="flex rounded-[10px] flex-col h-[150px] w-[280px] relative">
                <YouTube videoId={d?.video} opts={opts} />
              </div>
              <div className="w-[280px] pb-1 mt-1 border-b-2 border-b-[#B9B9B9]">
                <p className="text-[15px] xl:text-[16px] font-[600] tracking-[0.85px] xl:leading-snug">
                  {d?.title}
                </p>
                <p className="mt-[6px] xl:mt-[10px] text-[13px] xl:text-[14px] font-[600]">
                  {d?.timeInMinutes} min watch
                </p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  )
}

export default VideoLibrary
